import remote from '../remote'

const state = {
  vismaArticles: []
}

const getters = {
  VISMA_ARTICLES: state => {
    return state.vismaArticles
  },
  VISMA_ARTICLE_BY_ID: (state, getters) => (id) => {
    return state.vismaArticles.find(article => article.artNbr === id)
  },
  VISMA_ARTICLE_BY_REAL_ID: (state, getters) => (id) => {
    return state.vismaArticles.find(article => article.id === id)
  },
  VISMA_ARTICLE_FILTER_BY_ID: (state, getters) => (id) => {
    return state.vismaArticles.filter(article => article.artNbr.startsWith(id))
  }
}

const mutations = {
  SET_VISMA_ARTICLES: (state, payload) => {
    state.vismaArticles = payload
  },
  UPDATE_VISMA_ARTICLE_BY_ID: (state, article) => {
    state.vismaArticles = [
      ...state.vismaArticles.map(item => item.id !== article.id ? item : { ...item, ...article })
    ]
  }
}

const actions = {
  GET_VISMA_ARTICLES: async (context, payload) => {
    let { data } = await remote().get('/api/vismasync/articles')
    context.commit('SET_VISMA_ARTICLES', data)
  },
  UPDATE_VISMA_ARTICE_PRICE: async (context, article) => {
    let vArticle = context.getters.VISMA_ARTICLE_BY_REAL_ID(article.id)
    vArticle.data['price'] = {
      first: article.first,
      second: article.second,
      third: article.third,
      fourth: article.fourth,
      fifth: article.fifth,
      sixth: article.sixth
    }
    await remote().put('/api/vismasync/articles/' + article.id, {
      article: vArticle
    })
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/vismaart.js